<template>
  <div>
      <MainMenu />
      <el-breadcrumb separator="" style="top: 10px; position: relative; background-color: #eee; padding: 5px; border-radius: 25px;">
            
        <el-breadcrumb-item 
          v-for="(data, index) in $store.getters.getBreadcrumbs"
          :key="index">
          <span style=" color: #383838; font-size: 14px;">
            {{ data.crumbName}}
          </span>
        </el-breadcrumb-item>
        
      </el-breadcrumb>
      
      <!--<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
        <el-breadcrumb separator="/">
            
          <el-breadcrumb-item 
            v-for="(data, index) in $store.getters.getBreadcrumbs"
            :key="index">
            <a @click="goToHome" v-if="data.target !== undefined">
              <i v-if="data.icon !== undefined" :class="data.icon"></i> {{data.crumbName !== undefined ? data.crumbName : ''}}
            </a>
            <span v-else>
              <i v-if="data.icon !== undefined" :class="data.icon"></i> {{data.crumbName !== undefined ? data.crumbName : ''}}
            </span>
          </el-breadcrumb-item>
          
        </el-breadcrumb>

        <div style="text-align: right; padding-right: 5px; padding-top: 0px; ">
          
          <a @click="initiateCopy" :underline="true" style="border: black solid 1px; padding: 0px 0px 0px 3px; margin-right: 10px; cursor: pointer;">
            Device#
          </a>

          <el-tooltip class="item" effect="dark" content="Search">
            <a @click="$emit('openSearchBox')" style="cursor: pointer">
              Search <i class="el-icon-search" style="font-size: 18px; top: 2px; position: relative;"></i>
            </a>
          </el-tooltip>

          <span class="label" style="margin-right: 10px; margin-left: 20px; ">
            Logged in as {{$store.getters.getUserInformation.name}}
          </span>
          <el-badge is-dot class="item" type="warning" style="margin-right: 25px;">
            <el-tooltip class="item" effect="dark" content="Tasks">
              <a @click="$emit('openTaskBox')" style="cursor: pointer">
                <i class="el-icon-s-order" style="font-size: 16px;"></i>
              </a>
            </el-tooltip>
          </el-badge>
          
          <el-badge is-dot class="item" type="warning" style="margin-right: 25px;">
            <el-tooltip class="item" effect="dark" content="Notifications">
              <a @click="$emit('openNotificationBox')" style="cursor: pointer">
                <i class="el-icon-bell" style="font-size: 16px;"></i>
              </a>
            </el-tooltip>
          </el-badge>
          
          <el-badge is-dot class="item" type="warning" style="font-size: 10px;">
            <el-tooltip class="item" effect="dark" content="Chat">
              <a @click="$emit('openChatBox')" style="cursor: pointer">
                <i class="el-icon-chat-dot-square" style="font-size: 16px;"></i>
              </a>
            </el-tooltip>
          </el-badge>
        </div>
      </div>-->
      <br><br>
    
  </div>
</template>

<script>
import MainMenu from './MainMenu.vue'

export default {
    components: {MainMenu},
    methods: {
      initiateCopy() {
        this.$store.dispatch('copyInformation', this.$store.getters.getMachineId)
      },
      openHelpSite() {
        window.open('https://reachus.easytailorapp.com')
      },
      goToHome() {
        this.$store.state.master.breadcrumbs = [{icon: 'el-icon-s-home', target: '/'}]
        this.$router.push('/')
      },
      saveBookmark() {
        this.$store.dispatch('saveBookmark', {page_id: this.$store.getters.getAccessRights.id})
      }

    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Header.vue